import { getBrandAdminApiBaseUrl } from '../../brand-admin/utils/apiConfig';

/** Brand admin API base (OTP, page-setup proxy target on E2E). */
export function getBrandAdminBackendUrl() {
  return getBrandAdminApiBaseUrl();
}
